exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".svg-inline--fa.fa-w-12{width:.4em!important}#map-icon,.application--light .icon{margin-left:5px}#map-icon{width:1.6em!important}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/CompareSec.vue"],"names":[],"mappings":"AACA,wBACI,oBAAwB,CAC3B,AAKD,oCAFI,eAAiB,CAKpB,AAHD,UAEI,qBAAuB,CAC1B","file":"CompareSec.vue","sourcesContent":["\n.svg-inline--fa.fa-w-12 {\n    width: .40em !important;\n}\n.application--light .icon {\n    /* color: inherit !important; */\n    margin-left: 5px;\n}\n#map-icon {\n    margin-left: 5px;\n    width:1.6em !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-795a4ea2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboards/car/mainCar/CompareSec.vue
// module id = 907
// module chunks = 17